export type MainRegionArea = 'gnb' | 'content' | 'footer' | 'zoom';

let lastTransition: { from: MainRegionArea; to: MainRegionArea } | null = null;

export const recordRegionTransition = (from: MainRegionArea, to: MainRegionArea) => {
    if (from === to) return;
    lastTransition = { from, to };
};

export const getPreviousRegionFromHistory = (currentArea: MainRegionArea): MainRegionArea | null => {
    if (lastTransition?.to === currentArea) {
        return lastTransition.from;
    }
    return null;
};

export const clearRegionTransitionHistory = () => {
    lastTransition = null;
};
